import { ProductGroups } from 'enums';
import React from 'react';
import { Outlet } from 'react-router';

export interface CoPilotOutletContext {
  productGroup: ProductGroups;
}

interface Props {
  productGroup: ProductGroups;
}

const CoPilotRootLayout: React.FC<Props> = ({ productGroup }) => {
  return <Outlet context={{ productGroup }} />;
};

export default CoPilotRootLayout;
